export const events = {
  // 非游客用户
  userNotLogedIn: 'userNotLogedIn',
  // 黑名单
  userInvalid: 'userInvalid',
  // rummy加载信息
  rummyLoaded: 'rummyLoaded',
};